import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, throwError } from 'rxjs';
import * as _ from 'lodash'

import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  public downloadSideBarSource = new BehaviorSubject<boolean>(false);
  private downloadListSource = new BehaviorSubject<any>([]);
  showSideBar = this.downloadSideBarSource.asObservable();
  downloadList = this.downloadListSource.asObservable();

  isIntervalALive: boolean = false;
  interval: any
  constructor(private _utilService: UtilsService) { }

  showDownloadSideBar(flag: boolean) {
    this.downloadSideBarSource.next(flag)
  }

  updateList(item: any) {
    item.filename = item.report_name ? item.report_name.split(' ').join('_') : item.filename
    item.fileType = item.fileType ? item.fileType : "csv"
    const currentValue = this.downloadListSource.value;
    const updatedValue = [...currentValue, item];
    this.downloadListSource.next(updatedValue);
    if (!this.isIntervalALive) {
      this.isIntervalALive = true
      this.interval = setInterval(() => {
        this.checkDashboardReportStatus()
      }, 30000)
    }
  }

  updateDateInList(item: any) {
    const currentValue = this.downloadListSource.value;
    const index = _.findIndex(currentValue, item);
    currentValue[index] = item;
    this.downloadListSource.next(currentValue);
  }

  removeDataFromList(item: any) {
    const currentValue = this.downloadListSource.value;
    const index = _.findIndex(currentValue, item);
    currentValue.splice(index, 1)
    this.downloadListSource.next(currentValue);
  }
  getDownloadId() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  checkDashboardReportStatus() {
    const currentValue = this.downloadListSource.value;
    const filteredList = _.filter(currentValue, (item: any) => {
      return ((!item.dataSource || item.dataSource != 'dashboard') && !item.processed)
    })
    if (!filteredList || filteredList.length <= 0) {
      clearInterval(this.interval)
      this.isIntervalALive = false
    } else {
      const job_id_list = _.map(filteredList, "_id")
      this.getDashboardReportFromJob({ job_id_list }).subscribe((respone: any) => {
        if (respone.code == 0 && respone.litmus_jobs) {
          for (var idx = 0; idx < currentValue.length; idx++) {
            var reportJobId = currentValue[idx]._id;
            for (var idy = 0; idy < respone.litmus_jobs.length; idy++) {
              if (reportJobId == respone.litmus_jobs[idy]._id) {
                currentValue[idx] = respone.litmus_jobs[idy];
              }
            }
          }
          this.downloadListSource.next(currentValue)
        }
      })
    }

  }

  getDashboardReportFromJob(requestData: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.getDashboardReport);
      return this._utilService.postAPICall(url, requestData, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }

  createDashboardReportingJob(requestData: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.create_dashboard_reporting_job);
      return this._utilService.postAPICall(url, requestData, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }
  

  createDashboardReportJob(requestData: any) {
    try {
      // var downloadQuery: any = {};
      // downloadQuery.brand_id = Helpers.brandDetail._id;
      // downloadQuery.field_id = _this.selectedCustomFilter.field_id;
      // downloadQuery.field_type = _this.selectedCustomFilter.type;
      // downloadQuery.api_url = $rootScope.Helpers.getApiUrlV2('v1/litmus_actions/comparison');
      // downloadQuery.question_id = _this.selectedQuestion.field_id;
      // downloadQuery.parameters = [];
      // downloadQuery.search_possible_values = false;
      // downloadQuery.job_name = "action_dashboard_reporting"
      // downloadQuery.job_type = 9
      // // downloadQuery.report_name = 'Action Summary - ' + _this.selectedCustomFilter.name;
      // var tabName = getCurrentTabNameForReport()
      // downloadQuery.report_name = 'Action Summary - ' + tabName + ' - ' + _this.selectedCustomFilter.name;
      // if (Helpers.hasProperty($rootScope, 'filterObj.nextFilter.field_id')) {
      //   downloadQuery.field_id = _this.selectedCustomFilter.field_id;
      //   downloadQuery.field_type = _this.selectedCustomFilter.type;
      // }
      // var universalFilter = Helpers.getUniversalFilter();
      // if (_this.overallWidgetDataQuery && _this.overallWidgetDataQuery.query) {
      //   downloadQuery.parameters.push(Helpers.deepClone(_this.overallWidgetDataQuery.query));
      // }
      // for (var idx in _this.drillDownSequence) {
      //   if (_this.drillDownSequence[idx].enabled && _this.drillDownExportDataQuery[idx].query) {
      //     downloadQuery.parameters.push(_this.drillDownExportDataQuery[idx].query)
      //   }
      // }
      // if (_this.compLeaderboardExportDataQuery && _this.compLeaderboardExportDataQuery.query && _this.enableLeaderboardComponent) {
      //   downloadQuery.parameters.push(Helpers.deepClone(_this.compLeaderboardExportDataQuery.query));
      //   downloadQuery.search_possible_values = true;
      // }
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.createDownloadJob);
      return this._utilService.postAPICall(url, requestData, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }
}
